import { TerminologyAttribute } from 'app/mdm/terminology-lib/services/terminology-attribute';
import { DateRange } from '@heda/core-util';

export class Dictionary {
  public id: string;
  public names: { [key: string]: string };
  public title: { [key: string]: string };
  public publisher: string;

  public attributes: Array<TerminologyAttribute>;
  public notes: any;

  public version: DictionaryVersion;
}

export class DictionaryVersion {
  public version: number;
  public status: string;
  public description: string;
  public valid?: DateRange;
  public concepts: DictionaryConcept[];
}

export class DictionaryConcept {
  public code: string;
  public parent: string;
  public attributes?: { [key: string]: any };
  public children?: Array<DictionaryConcept>;
}
